const BASE_REGEX_FIELDS = {
  text: {
    regex: '.+'
  },

  number: {
    regex: '[0-9]+'
  },

  price: {
    regex: '[0-9]+[.,]?[0-9]*',
    ge: 0
  },

  discount: {
    regex: '[0-9]+[.,]?[0-9]*',
    ge: 0,
    le: 100
  },

  url: {
    regex: '^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$',
    restrictedChars: ' ',
    flags: 'i'
  },

  phoneNumber: {
    regex: '^([+]?[(]?[0-9]{1,4}[)]?)?[- 0-9]{8,12}[0-9]$'
  },

  email: {
    regex: `^.+[@]{1}.+[.]{1}.+$`
  },

  password: {
    regex: '.+'
  },

  vatId: {
    regex: `^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$`
  }
}

export default {
  /**
   * Makes a constraints object
   * @param {String} preset Regex preset to use
   * @param {Object} params Overwrite params
   * @returns {Object}
   */
  build (preset, params = {}) {
    let errorMsg = { errorMsg: `Input.constraint.${preset}.errorMsg` }
    return Object.assign({}, BASE_REGEX_FIELDS[preset] || {}, errorMsg, params)
  }
}
  


// WEBPACK FOOTER //
// ./src/assets/modules/constraints/constraintBuilder.js